import PubSub from "underpub-js";

var ListingUnitsDirectoryFilters = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-ListingUnitsDirectoryFilters',
	};

	$.extend(true, this.options, options);

};

ListingUnitsDirectoryFilters.prototype.init = function() {

	var self = this;

};

export default ListingUnitsDirectoryFilters;
